import React, { useEffect, useState, useRef, useContext } from 'react';
import { MobiOrNotContext } from '../../ContextApi/context';

const DropHouresSelection = (props) => {
  const [mobiOrNot] = useContext(MobiOrNotContext);

  const [isOpen, setIsOpen] = useState(false);
  const [numberOptions, setNumberOptions] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    getTimesList();
  }, [props.slots, props.fromHour, props.toHour]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  // רשימת השעות מגיעה מבחוץ לפי ההגדרות בניהול.
  // הנפילה חזרה ל-fromHour/toHour נשארת עבור מי שמשתמש ברכיב בלי slots
  const getTimesList = () => {
    if (props.slots) {
      setNumberOptions(props.slots);
      return;
    }

    let timeSlots = [];
    let strttm = props.fromHour;
    let endttm = props.toHour - 1;
    for (let hour = strttm; hour <= endttm; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const formattedHour = hour.toString().padStart(2, '0');
        const formattedMinute = minute.toString().padStart(2, '0');
        timeSlots.push(`${formattedHour}:${formattedMinute}`);
      }
    }

    setNumberOptions(timeSlots);
  };

  return (
    <div style={props.wrpaStyl}>
      <input
        onClick={() => {
          setIsOpen((prevState) => !prevState);
        }}
        readOnly
        type='text'
        className={"inputsStyle pointing"}
        value={`${props.lbl} ${props.Val}`}
      />
      <div
        className={`${props.drpArrCss} pointing`}
        onClick={() => {
          setIsOpen((prevState) => !prevState);
        }}
        style={{ backgroundImage: `url("/PermanentImages/drpArrowWh.png")` }}
      ></div>

      <div ref={dropdownRef}>
        {(mobiOrNot) ?
          (isOpen) ?
            <div className='mobiDropSelectonOpts'>
               <p style={{position:'fixed'}}>לאיזה שעה?</p>
              {
                (numberOptions.length === 0) ?
                  <div className='fullRow'>אין שעות פנויות בתאריך זה</div> : ""
              }
              {
                numberOptions.map((time) => (
                  <div className='fullRow' onClick={(e) => {
                    props.settingFunc(time);
                    setIsOpen(false);
                  }} key={time} value={time}>
                    {time}
                  </div>
                ))
              }
            </div> : ""
          :
          (isOpen) ?
            <div style={props.selectionstyl}>
              <select
                className={props.Css}
                value={props.Val}
                onChange={(e) => {
                  props.settingFunc(e.target.value);
                  setIsOpen(false);
                }}
                onBlur={() => setIsOpen(false)}
                size={Math.min(Math.max(numberOptions.length, 1), 10)}
              >
                {(numberOptions.length === 0) ?
                  <option value={""}>אין שעות פנויות בתאריך זה</option> : ""}
                {numberOptions.map((time) => (
                  <option key={time} value={time}>
                    {time}
                  </option>
                ))}
              </select>
            </div>
            : ""
        }
      </div>
    </div>
  );
};

export default DropHouresSelection;
